import { Link } from "react-router-dom";
import CertificadoTable from "../../../Components/Populados/Pessoa/Empresa/Certificado/CertificadoTable";
import { Button, Divider, Form, Row } from "antd";
import Col from "antd/lib/grid/col";
import Certificado from "../../../Models/Faturamento/Certificado";
import EmpresaSelect from "../../../Components/Populados/Pessoa/Empresa/EmpresaSelect";

export default function Consulta() {
    const [formulario] = Form.useForm<Certificado>();
    const certificado = Form.useWatch([], formulario);

    return <Form
        layout="vertical"
        autoComplete="off"
        form={formulario}
    >
        <Row gutter={8} wrap>
            <Col xs={24}>
                <Form.Item name={["codPessoa"]} label={"Empresa"} >
                    <EmpresaSelect />
                </Form.Item>
            </Col>
            <Col xs={"auto"}>
                <Link to={"../adicionar"}>
                    <Button type="primary" style={{ width: "100%" }}>
                        Adicionar
                    </Button>
                </Link>
            </Col>
            <Divider />
            <Col xs={24}>
                <CertificadoTable filtros={{
                    certificado: certificado
                }} />
            </Col>
        </Row>
    </Form>;
}